<app-header *ngIf="isLoggedIn" [sidenav]="sidenav"></app-header>
<mat-sidenav-container class="sideNavContainer">
    <mat-sidenav #sidenav mode="side" [style.display]="isLoggedIn != true?'none': 'block'">
        <mat-nav-list>
            <mat-list-item [routerLink]="['/home']" routerLinkActive="active" matTooltip="Admin">
                <mat-icon matListItemIcon>home</mat-icon><a matListItemTitle>Home</a>
            </mat-list-item>
            <mat-list-item [routerLink]="['/add-new-assessment']" routerLinkActive="active" matTooltip="Admin">
                <mat-icon matListItemIcon>quiz</mat-icon><a matListItemTitle>Add New Assessment</a>
            </mat-list-item>
            <mat-list-item [routerLink]="['/add-new-course']" routerLinkActive="active" matTooltip="Admin">
                <mat-icon matListItemIcon>library_add</mat-icon><a matListItemTitle>Add New Program</a>
            </mat-list-item>
            <mat-list-item [routerLink]="['/add-file-name']" routerLinkActive="active" matTooltip="Admin">
                <mat-icon matListItemIcon>post_add</mat-icon><a matListItemTitle>Add Report Name</a>
            </mat-list-item>
            <mat-list-item [routerLink]="['/icaf-dashboard']" routerLinkActive="active" matTooltip="Admin">
                <mat-icon matListItemIcon>post_add</mat-icon><a matListItemTitle>ICAF Dashboard</a>
            </mat-list-item>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
        <app-loader></app-loader>
        <div class="page-wrapper-container">
            <router-outlet></router-outlet>
            <app-footer *ngIf="isLoggedIn" ></app-footer>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>